import { useMutation, useQuery } from '@tanstack/react-query';
import { connectByCredentials, queryClient, setDefaultConnectedServices } from '../index';
import { oauthKeys } from './oauth.keys';
import { getIntegrations, authStart, authCallback, disconnect } from './oauth.api';
export const useIntegrationsQuery = () => {
    return useQuery({
        queryKey: oauthKeys.integrations(),
        queryFn: () => getIntegrations()
    });
};
export const useConnectMutation = () => {
    return useMutation({
        mutationFn: connectByCredentials,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: oauthKeys.integrations() }).then();
        }
    });
};
export const useStartQuery = (oauthType) => {
    return useQuery({
        queryKey: oauthKeys.start(oauthType),
        queryFn: () => authStart(oauthType),
        staleTime: 0
    });
};
export const useAuthCallbackMutation = () => {
    return useMutation({
        mutationFn: authCallback,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: oauthKeys.integrations() }).then();
        }
    });
};
export const useSetDefaultMutation = () => {
    return useMutation({
        mutationFn: setDefaultConnectedServices,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: oauthKeys.integrations() }).then();
        }
    });
};
export const useDisconnectMutation = () => {
    return useMutation({
        mutationFn: disconnect,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: oauthKeys.integrations() }).then();
        }
    });
};
//# sourceMappingURL=oauth.query.js.map